<router-outlet></router-outlet>
<rc-toast class="absolute inset-x-24 top-5 drop-shadow-2xl"></rc-toast>
